<div
  *ngIf="cardLayoutType === 'individual' && cardsInfo.length > 0 && selectedCard !== undefined"
  [ngStyle]="contentStyle"
>
  <div
    [style.width]="getCardTypeStyle(cardsInfo[0]).width"
    [style.min-height]="getCardTypeStyle(cardsInfo[0]).height"
    class="flip-card-container"
  >
    <div
      *ngIf="flipCardEnabled && cardsInfo[0].id === selectedCard.id"
      class="flip-card-overlay"
      [ngStyle]="iconPlacement"
      [style.padding]="iconPadding"
    >
      <button (click)="flipCard()" class="flip-card-button is-center">
        @if (isIconAvailable) {
          <img [ngStyle]="iconStyle" [src]="iconPath" alt="Flip Card" />
        } @else {
          <mat-icon [ngStyle]="iconStyle" [svgIcon]="iconPath"></mat-icon>
        }
      </button>
    </div>
    <div [ngClass]="{ 'card-flip': isFlipped }">
      <div class="card-front">
        <finxone-web-frontend-card
          [cardDetails]="cardsInfo[0]"
          [ngStyle]="setCardStylesAndFillWidth(cardsInfo[0])"
          class="d-flex"
          (click)="handleCardClicked(cardsInfo[0])"
          (templateAction)="handleCardTemplateAction($event, cardsInfo[0])"
          [content]="getCardTemplate(cardsInfo[0])"
          [frozenOverlayContent]="isFlipped ? '' : getFrozenOverlayTemplate(cardsInfo[0])"
          [flippedCardTemplate]="getFlippedTemplate(cardsInfo[0])"
          [secureCVVDetails]="secureCVVDetails"
          [ngClass]="{ 'pointer-events-none': isWorkflow }"
        ></finxone-web-frontend-card>
      </div>

      <div class="card-back">
        <finxone-web-frontend-card
          [cardDetails]="cardsInfo[0]"
          [ngStyle]="setCardStylesAndFillWidth(cardsInfo[0])"
          class="d-flex"
          [isFlipped]="isFlipped"
          [content]="showBackTemplate ? getCardTemplate(cardsInfo[0]) : ' '"
          [flippedCardTemplate]="getFlippedTemplate(cardsInfo[0])"
          [secureCVVDetails]="secureCVVDetails"
          [backCardTextStyles]="backCardTextStyles"
        ></finxone-web-frontend-card>
      </div>
    </div>
  </div>
</div>
<div *ngIf="cardLayoutType === 'carousel' && cardsInfo.length > 0" [ngStyle]="contentStyle">
  <div class="carousel-inner w-100" role="listbox">
    <drag-scroll (indexChanged)="indexChanged($event)">
      <ng-container>
        @for (card of cardsInfo; let index = $index; track card.id) {
          <div drag-scroll-item class="drag-scroll-item w-100" style="margin-right: 0.9rem">
            <div
              [style.width]="getCardTypeStyle(card).width"
              [style.min-height]="getCardTypeStyle(card).height"
              class="flip-card-container"
            >
              <!-- <div
              *ngIf="flipCardEnabled && card.id === selectedCard.id"
              class="flip-card-overlay"
              [ngStyle]="iconPlacement"
              [style.padding]="iconPadding"
            >
              <button (click)="flipCard()" class="flip-card-button is-center">
                @if(isIconAvailable){
                <img [ngStyle]="iconStyle" [src]="iconPath" alt="Flip Card" />
                } @else{
                <mat-icon [ngStyle]="iconStyle" [svgIcon]="iconPath"></mat-icon>
                }
              </button>
            </div> -->
              <div [ngClass]="{ 'card-flip': isFlipped && card.id === selectedCard.id }">
                <div class="card-front">
                  <finxone-web-frontend-card
                    [cardDetails]="card"
                    [ngStyle]="getCardTypeStyle(card)"
                    class="d-flex"
                    (click)="handleCardClicked(card)"
                    (templateAction)="handleCardTemplateAction($event, card)"
                    [content]="getCardTemplate(card)"
                    [frozenOverlayContent]="getFrozenOverlayTemplate(card)"
                    [flippedCardTemplate]="getFlippedTemplate(card)"
                    [secureCVVDetails]="secureCVVDetails"
                    [ngClass]="{ 'pointer-events-none': isWorkflow }"
                  ></finxone-web-frontend-card>
                </div>

                <div class="card-back">
                  <finxone-web-frontend-card
                    [cardDetails]="card"
                    [ngStyle]="setCardStylesAndFillWidth(card)"
                    class="d-flex"
                    [isFlipped]="isFlipped && card.id === selectedCard.id"
                    [content]="showBackTemplate ? getCardTemplate(card) : ' '"
                    [secureCVVDetails]="secureCVVDetails"
                    [flippedCardTemplate]="getFlippedTemplate(card)"
                    [backCardTextStyles]="backCardTextStyles"
                  ></finxone-web-frontend-card>
                </div>
              </div>
            </div>
          </div>
        }
      </ng-container>
    </drag-scroll>
  </div>
</div>
<div *ngIf="cardLayoutType === 'listing' && cardsInfo.length > 0" class="h-100" [ngStyle]="contentStyle">
  <div (scroll)="onScroll($event)" class="list-wrapper h-100 w-100">
    @for (card of cardsInfo; let index = $index; track card.id) {
      <div class="mb-2">
        <div
          [style.width]="getCardTypeStyle(card).width"
          [style.min-height]="getCardTypeStyle(card).height"
          class="flip-card-container"
        >
          <!-- <div
          *ngIf="flipCardEnabled && card.id === selectedCard.id"
          class="flip-card-overlay"
          [ngStyle]="iconPlacement"
          [style.padding]="iconPadding"
        >
          <button (click)="flipCard()" class="flip-card-button is-center">
            @if(isIconAvailable){
            <img [ngStyle]="iconStyle" [src]="iconPath" alt="Flip Card" />
            } @else{
            <mat-icon [ngStyle]="iconStyle" [svgIcon]="iconPath"></mat-icon>
            }
          </button>
        </div> -->
          <div [ngClass]="{ 'card-flip': isFlipped && card.id === selectedCard.id }">
            <div class="card-front">
              <finxone-web-frontend-card
                [cardDetails]="card"
                [ngStyle]="getCardTypeStyle(card)"
                class="d-flex"
                (click)="handleCardClicked(card)"
                (templateAction)="handleCardTemplateAction($event, card)"
                [content]="getCardTemplate(card)"
                [frozenOverlayContent]="getFrozenOverlayTemplate(card)"
                [flippedCardTemplate]="getFlippedTemplate(card)"
                [secureCVVDetails]="secureCVVDetails"
                [ngClass]="{ 'pointer-events-none': isWorkflow }"
              ></finxone-web-frontend-card>
            </div>

            <div class="card-back">
              <finxone-web-frontend-card
                [cardDetails]="card"
                [ngStyle]="setCardStylesAndFillWidth(card)"
                class="d-flex"
                [isFlipped]="isFlipped && card.id === selectedCard.id"
                [content]="showBackTemplate ? getCardTemplate(card) : ' '"
                [flippedCardTemplate]="getFlippedTemplate(card)"
                [secureCVVDetails]="secureCVVDetails"
                [backCardTextStyles]="backCardTextStyles"
              ></finxone-web-frontend-card>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</div>
<div *ngIf="cardsInfo.length === 0">
  <finxone-web-frontend-card
    [ngStyle]="getCardTypeStyle()"
    [content]="getCardTemplate()"
    [frozenOverlayContent]="getFrozenOverlayTemplate()"
    (click)="handleCardClicked()"
    (templateAction)="handleCardTemplateAction($event)"
    class="d-flex"
    [ngClass]="{ 'pointer-events-none': isWorkflow }"
  ></finxone-web-frontend-card>
</div>
